import React from 'react';
import classnames from 'classnames';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core';

import { colorPalette } from '../../styles/customStyling';

import LearnIcon from '../../images/LearnIcon.svg';
import ReferencesIcon from '../../images/ReferencesIcon.svg';
import TimeIcon from '../../images/TimeIcon.svg';

const styles = (theme: Theme) => ({
  mainContainer: {
    width: '100%'
  },
  firstContainer: {
    textAlign: 'center' as 'center',
    backgroundColor: colorPalette.backgroundTanExtraLight,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5)
  },
  joinNetwork: {
    color: colorPalette.blueExtraDark,
    fontSize: 14,
    fontWeight: 500,
    margin: 0
  },
  becomePartner: {
    color: colorPalette.slOrange,
    fontSize: 40,
    fontWeight: 300,
    letterSpacing: 0.6,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  gainAccess: {
    color: colorPalette.blueExtraDark,
    fontSize: 22,
    fontWeight: 300,
    letterSpacing: 0.6,
    lineHeight: '32px',
    maxWidth: 600,
    margin: '0 auto'
  },
  secondContainer: {
    backgroundColor: colorPalette.backgroundTanLight,
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(12),
    paddingRight: theme.spacing(12),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6)
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  beforeYouStart: {
    fontSize: 22,
    color: colorPalette.greyDark,
    fontWeight: 300,
    letterSpacing: 0.6,
    textAlign: 'center' as 'center'
  },
  columnsContainer: {
    fontSize: 16,
    display: 'flex',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column' as 'column'
    }
  },
  column: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 'fit-content',
    maxWidth: 222,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'row-reverse' as 'row-reverse',
      maxWidth: 'unset',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  },
  middleElement: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  columnParagraph: {
    color: colorPalette.greyDark,
    textAlign: 'center' as 'center',
    marginTop: theme.spacing(3),
    marginBottom: 0,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
      marginTop: 0,
      width: '70%'
    }
  },
  iconContainer: {
    width: 'fit-content',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
      width: '20%'
    }
  },
  icon: {
    height: 64,
    [theme.breakpoints.down('xs')]: {
      height: 48
    }
  },
  progressNotSaved: {
    textAlign: 'center' as 'center',
    fontSize: 18,
    fontWeight: 300,
    marginTop: theme.spacing(9),
    marginBottom: 0
  }
});

// Start typescript definitions
interface OwnProps extends WithStyles<typeof styles> {}
// End typescript definitions

export const FirstPageHeader = ({ classes }: OwnProps) => (
  <div className={classes.mainContainer}>
    <div className={classes.firstContainer}>
      <p className={classes.joinNetwork}>Join Our Network</p>
      <p className={classes.becomePartner}>Become a Shorelight Partner</p>
      <p className={classes.gainAccess}>
        Gain access to the fastest-growing portfolio of top tier universities and a world-class
        support network.
      </p>
    </div>
    <div className={classes.secondContainer}>
      <p className={classes.beforeYouStart}>A few things before you start:</p>
      <div className={classes.columnsContainer}>
        <div className={classes.column}>
          <span className={classes.iconContainer}>
            <img src={TimeIcon} alt="timeIcon" className={classes.icon} />
          </span>
          <p className={classes.columnParagraph}>
            It will only take a <b>few minutes</b> to complete your partnership application.
          </p>
        </div>
        <div className={classnames(classes.column, classes.middleElement)}>
          <span className={classes.iconContainer}>
            <img src={ReferencesIcon} alt="referencesIcon" className={classes.icon} />
          </span>
          <p className={classes.columnParagraph}>
            You will need <b>2 references</b> from education agencies or university partners that
            you have previously worked with.
          </p>
        </div>
        <div className={classes.column}>
          <span className={classes.iconContainer}>
            <img src={LearnIcon} alt="learnIcon" className={classes.icon} />
          </span>
          <p className={classes.columnParagraph}>
            While your application is under review, start training and{' '}
            <b>learn about Shorelight.</b>
          </p>
        </div>
      </div>
      <p className={classes.progressNotSaved}>Please note that your progress will not be saved.</p>
    </div>
  </div>
);

export default withStyles(styles)(FirstPageHeader);
